import React from 'react'
import { BaseCard } from './BaseCard'
import { APIClient } from '@/services'
import { Select } from '@/components'
import { RenderItemProps } from '../types'
import { useProfilePrompt } from '../../useProfilePrompt'

export const JobRoleCard = ({ item }: RenderItemProps) => {
  const { data: options } = APIClient.Session.useProfileOptions()

  const prompt = useProfilePrompt(item)

  return (
    <BaseCard prompt={prompt}>
      <Select
        {...prompt.form.register('department')}
        options={options?.department}
        arrowIconName='chevron-right'
        placeholder='Select one'
        label='Job role'
        variants={['noError', 'prompt']}
        onMenuOpen={() => BaseCard.setOpenPortal(prompt, true)}
        onMenuClose={() => BaseCard.setOpenPortal(prompt, false)}
      />
    </BaseCard>
  )
}
